import { getSettlementStats } from "@/services/settlements.service";
import { useQuery } from "@tanstack/react-query";

export const useSettlementStats = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["settlementStats"],
    queryFn: getSettlementStats,
    select: (res) => res?.data,
  });

  return {
    stats: {
      totalCount: data?.totalCount ?? 0,
      totalVolume: data?.totalVolume ?? 0,
      successfulCount: data?.successfulCount ?? 0,
      pendingCount: data?.pendingCount ?? 0,
      failedCount: data?.failedCount ?? 0,
    },
    isLoading,
    isError,
  };
};
